/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import Moment from 'moment'
import React, {useEffect, useState} from 'react'
import * as a from '../../../../app/_ancientLibrary/components/'
import {HttpMethod, useAncientRequest} from '../../../../app/_ancientLibrary/utilities'
import {CollectionData, CollectionListModel} from '../../../../app/client/_models/collectionModels'
import {SpreadsheetManagerModal} from '../../../../app/client/user/collectionDetail/components/spreadsheetComponents'

type Props = {
  className: string
}
const APP_URL = process.env.REACT_APP_APP_URL

const DashboardToDoList: React.FC<Props> = ({className}) => {
  const ancientRequest = useAncientRequest()
  const [displaySpreadsheetModal, setDisplaySpreadsheetModal] = useState<boolean>(false)
  const [collectionList, setCollectionList] = useState<Array<CollectionListModel>>([])
  const [collectionDetail, setCollectionDetail] = useState<CollectionData>()
  const [collectionDetailParams, setCollectionDetailParams] = useState<any>()

  const loadCollections = (processStep: string) => {
    //Get New Collections
    ancientRequest(
      HttpMethod.GET,
      `/bm/CollectionsList/getCollections?periodTypes=&collectionTypes=&procesSteps=${processStep}&pageNumber=1&collectionUse=2&filterBySubscriptionType=true`,
      undefined,
      undefined
    ).then((response) => {
      setCollectionList((prevCollectionList) => [
        ...prevCollectionList,
        ...response.data.queryResult,
      ])
    })
  }

  useEffect(() => {
    setCollectionList([])
    loadCollections('02f6fd45-85c2-4ab4-b4c6-31f7749bf095') //New
    loadCollections('12f6fd45-85c2-4ab4-b4c6-31f7749bf095') //Saved
  }, [])

  const spreadsheetMaintenanceClose = () => {
    setDisplaySpreadsheetModal(false)
  }

  const goTo = (collection: CollectionListModel) => {
    switch (collection.formTypeId) {
      //Spreadsheet
      case 'b816976c-f04a-4fc2-abec-8112292eba6a':
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/bm/CollectionsDetail/getCollection/${collection.formTypeId}/${collection.companyId}/${collection.quarterID}`
          )
          .then((response) => {
            setCollectionDetail(response.data)
            setCollectionDetailParams({
              formTypeId: collection.formTypeId,
              companyId: collection.companyId,
              quarterID: collection.quarterID,
            })
          })
        break
      default:
        window.open(
          `${APP_URL}/c/collection/${collection.formTypeId}/${collection.companyId}/${collection.quarterID}`,
          '_blank',
          'noreferrer'
        )
        break
    }
  }
  React.useEffect(() => {
    if (collectionDetailParams) setDisplaySpreadsheetModal(true)
  }, [collectionDetailParams])

  const processStepColor = (processStep: string) => {
    switch (processStep) {
      case 'New': //New
        return 'success'
      case 'Saved': //Saved
        return 'primary'
    }
  }

  const dateDue = (collection: CollectionListModel) => {
    if (collection.dateDue) {
      // Parse the due date string into a moment object
      const dueDate = Moment(collection.dateDue)

      // Calculate the duration in days
      const duration = dueDate.diff(Moment(), 'days')

      // Use Moment.js's relative time feature to format the result
      const relativeDueDate = Moment.duration(duration, 'days').humanize()

      // Return the relative due date
      return `Due in ${relativeDueDate}`
    }

    return 'No due date specified' // Return a message if there's no due date
  }

  const CollectionItem = (collection: CollectionListModel, index: number) => {
    return (
      <div key={index} className='d-flex align-items-center mb-8'>
        {/* begin::Bullet */}
        <span
          className={`bullet bullet-vertical h-60px bg-${processStepColor(
            collection.processStepName
          )} mx-5`}
        ></span>
        {/* end::Bullet */}
        {/* begin::Description */}
        <div className='flex-grow-1'>
          <a
            href='#'
            className='text-gray-800 text-hover-primary fw-bolder fs-6'
            onClick={() => {
              goTo(collection)
            }}
          >
            {collection.companyName}
          </a>
          <span className='text-muted fw-bold d-block'>
            {collection.formTypeName} {collection.quarterDesc}
          </span>
          <span className='text-muted fw-bold d-block'>{dateDue(collection)}</span>
        </div>
        {/* end::Description */}
        <span
          className={`badge badge-light-${processStepColor(
            collection.processStepName
          )} fs-8 fw-bolder`}
        >
          {collection.processStepName}
        </span>
      </div>
    )
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title'>Todo List</h3>
        <div className='card-toolbar'></div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-2'>
        {collectionList.map((collection, index) => {
          return CollectionItem(collection, index)
        })}
      </div>

      {/* end::Body */}

      <a.AncientModal
        id='spreadsheet_manager'
        header='Spreadsheet Manager'
        isOpen={displaySpreadsheetModal}
        onClose={spreadsheetMaintenanceClose}
        className='modal-fullscreen'
      >
        <SpreadsheetManagerModal
          collection={collectionDetail?.collectionHeader}
          collectionYear={collectionDetail?.collectionQuarter?.dateEnd}
          formTypeId={collectionDetailParams?.formTypeId}
          companyId={collectionDetailParams?.companyId}
          quarterId={collectionDetailParams?.quarterID}
        ></SpreadsheetManagerModal>
      </a.AncientModal>
    </div>
  )
}

export {DashboardToDoList}
